module.exports = __webpack_public_path__ + "img/i-mail-admin.695f18f1.svg";